import React, { useEffect, useRef, useState } from "react";
import {
  Checkbox,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import moment from "moment";
import dayjs from "dayjs";
import { fetchFiscYear } from "../../../../features/dropdown/dropdownSlice";
import { monthsData } from "../../../../data";

const { TextArea } = Input;

const AddFiscalPeriodModal = ({
  open,
  handleCancel,
  handleFetchData,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const today = new Date();
  let dd = String(today.getDate()).padStart(2, 0);
  let mm = String(today.getMonth() + 1).padStart(2, 0);
  let yyyy = today.getFullYear() - 18;

  let minDate = `${yyyy}-${mm}-${dd}`;

  const { fiscalYear, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const [value, setValue] = useState(prodd?.fpActive ? true : false);

  const onChangeCheck = (e) => {
    setValue(e.target.checked);
  };

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  function onMonthChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  console.log("formData?.fpPyear", formData?.fpPyear);
  const onFinish = async (data) => {
    if (!formData?.fyId) {
      toast.error("Please select fiscal year");
      return;
    }
    if (!formData?.fpPmonth) {
      toast.error("Please select calendar month");
      return;
    }
    const res = await dispatch(
      save({
        fpId: prodd?.fpId ? prodd?.fpId : null,
        fyId: formData?.fyId,
        fpPyear: formData?.fpPyear,
        fpPmonth: formData?.fpPmonth,
        fpActive: value ? 1 : 0,
        url: "hr/saveFiscPeriod.action",
      })
    );

    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchFiscYearData() {
    dispatch(fetchFiscYear());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  useEffect(() => {
    setValue(prodd?.fpActive ? true : false);
  }, [prodd]);

 
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit fiscal period ${prodd?.fpPyear}`
            : "Add fiscal period details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            className=""
            label={<span>Fiscal Year</span>}
            rules={[
              {
                required: true,
                message: "Please select Fiscal Year",
              },
            ]}
          >
            <Select
              disabled={true}
              name="fyId"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                fiscalYear?.length > 0 &&
                fiscalYear?.map((item) => ({
                  value: item?.fyId,
                  label: item?.fyFiscalyear,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "fyId");
              }}
              value={formData?.fyId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchFiscYearData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>
          <Form.Item
            label="Calendar Year"
            rules={[
              {
                required: true,
                message: "Calendar Year required",
              },
            ]}
          >
            <DatePicker
              disabled={true}
              name="fpPyear"
              className="input"
              picker="year"
              format={"YYYY"}
              placeholder={
                formData?.fpPyear ? formData.fpPyear.toString() : "Select Year"
              }
              value={
                formData?.fpPyear ? dayjs(`${formData.fpPyear}`, "YYYY") : null
              }
              onChange={(value) => {
                onMonthChange(value, "fpPyear");
              }}
            />
          </Form.Item>

          <Form.Item
            className=""
            label={<span>Calendar Month</span>}
            rules={[
              {
                required: true,
                message: "Please select Calendar Month",
              },
            ]}
          >
            <Select
              disabled={true}
              name="fpPmonth"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                monthsData?.length > 0 &&
                monthsData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "fpPmonth");
              }}
              value={formData?.fpPmonth}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item>
            <Checkbox checked={value} onChange={onChangeCheck}>
              Active
            </Checkbox>
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddFiscalPeriodModal;
